import { Component, inject, OnDestroy, OnInit, signal, computed, model, output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { HomepageCardMenuComponent } from '../../shared/components/card-menu/card-menu.component';
import { MenuItem } from '../../shared/models/side-menu.model';
import { MenuStateService } from '../../core/services/menu-state.service';
import { ResponseData } from '@shared/helpers/response-data';
import { CommonModule } from '@angular/common';
import { collectFavoritesByRootParent } from '../../shared/utils/menu-filter';
import { NoFavoritesComponent } from '../no-favorites/no-favorites.component';
import { MenuService } from '../../core/services/menu.service';

@Component({
  selector: 'app-favorites-cards',
  standalone: true,
  imports: [CommonModule, HomepageCardMenuComponent, NoFavoritesComponent],
  templateUrl: './favorites-cards.component.html',
  styleUrl: './favorites-cards.component.scss'
})
export class FavoritesCardsComponent implements OnInit, OnDestroy {
  readonly #menuStateService = inject(MenuStateService);

  displayedMenuItems = model<MenuItem[]>([]);
  menuData = signal<ResponseData<MenuItem[]>>({
    data: null,
    status: 'loading'
  });

  showAllGroups = signal<boolean>(false);

  groupedFavorites = computed(() => {
    const data = this.displayedMenuItems();
    if (!data || this.menuData().status !== 'success') return [];

    const grouped = collectFavoritesByRootParent(data);
    return grouped;
  });

  onToggleFavorite = output<MenuItem>();

  private destroy$ = new Subject<boolean>();

  ngOnInit(): void {
    this.#listenerMenuItems();
  }

  #listenerMenuItems(): void {
    this.#menuStateService.menuItems$
      .pipe(takeUntil(this.destroy$))
      .subscribe((menuData) => {
        this.menuData.set(menuData);
        this.showAllGroups.set(false);
      });
  }

  onCardClicked(menuItem: MenuItem): void {
    if (menuItem.link) window.open(menuItem.link, '_blank');
  }

  emitToggleFavorite(menuItem: MenuItem): void {
    this.onToggleFavorite.emit(menuItem);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
